export default "<div class=\"text\">\n   {{ text }}\n</div>\n<div  class=\"frame\"></div>\n"